import { GlobalReactQueryOptions } from '../../config';
import { useQuery } from '@tanstack/react-query';
import { fetchLanguageProducts } from './fetchLanguageProducts';
import { Pagination } from '../../../models/Pagination';
import { browserClient } from '../../react-query';
import { AgeCategory } from '../../../models/AgeCategory';

const LANGUAGE_LEARNING_PRODUCTS_QUERY_KEY = 'languageLearningProducts';
const LOTE_PRODUCTS_QUERY_KEY = 'loteProducts';

export interface UseLanguageLearningProductsOptions {
    loanFormat: string | null;
    filterMap?: any;
    language?: string;
    pagination: Pagination;
    ageCategory: AgeCategory;
    isLanguageLearningScope: boolean;
    shopLanguage: string | undefined;
}

export const useLanguageProducts = ({
    loanFormat,
    filterMap,
    language,
    pagination,
    ageCategory,
    isLanguageLearningScope,
    shopLanguage
}: UseLanguageLearningProductsOptions) => {
    const transformedFilterMap = JSON.stringify(filterMap);
    const queryKey = isLanguageLearningScope ? LANGUAGE_LEARNING_PRODUCTS_QUERY_KEY : LOTE_PRODUCTS_QUERY_KEY;

    const { data, ...result } = useQuery(
        [queryKey, { loanFormat, transformedFilterMap, language, ageCategory, shopLanguage, ...pagination }],
        () =>
            fetchLanguageProducts({
                loanFormat,
                filterMap: transformedFilterMap,
                language,
                ageCategory,
                pagination,
                isLanguageLearningScope,
                shopLanguage
            }),
        {
            ...GlobalReactQueryOptions
        }
    );

    return {
        ...result,
        data: data ?? { total: 0, products: [] }
    };
};

export function invalidateLanguageProducts(isLanguageLearningScope: boolean) {
    return browserClient.invalidateQueries({
        queryKey: [isLanguageLearningScope ? LANGUAGE_LEARNING_PRODUCTS_QUERY_KEY : LOTE_PRODUCTS_QUERY_KEY]
    });
}
